// extracted by mini-css-extract-plugin
export default {"box":"style_box__oYiK1","box__header":"style_box__header__pWDNx","box__body":"style_box__body__7B3VY"};